import { render, staticRenderFns } from "./DSelectPreview.vue?vue&type=template&id=045c6dc8&"
import script from "./DSelectPreview.vue?vue&type=script&lang=js&"
export * from "./DSelectPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports